import React from "react";
import { COLORS } from "../myDashboardConstants";

export function Badge({
  label,
  styleMap,
  fallback = { color: COLORS.muted, soft: "#F1F5F9" },
}) {
  const s = (styleMap && styleMap[label]) || fallback;
  return (
    <span className="sd-badge" style={{ color: s.color, background: s.soft }}>
      {label}
    </span>
  );
}
